import type { CSSProperties } from "react";

/** Source dimensions and the symbol's bounds; full originals retain their provenance. */
export type ArtworkCrop = readonly [
  imageWidth: number,
  imageHeight: number,
  x: number,
  y: number,
  width: number,
  height: number,
];
export const ISSUER_SYMBOL_CROPS: Readonly<Record<string, ArtworkCrop>> = {
  adgm: [3000, 1069, 0, 0, 1050, 1069],
  austrac: [700, 535, 175, 20, 350, 265],
  bma: [232, 140, 116, 0, 116, 112],
  cbi: [288, 126, 0, 28, 70, 70],
  ccab: [229, 93, 0, 0, 53, 93],
  cis: [300, 142, 0, 0, 135, 142],
  dfsa: [1022, 678, 60, 40, 890, 470],
  difc: [1677, 635, 0, 0, 610, 635],
  fatf: [1200, 756, 160, 115, 215, 400],
  fca: [320, 101, 0, 0, 182, 101],
  fiau: [567, 179, 0, 0, 177, 179],
  finma: [412, 94, 0, 0, 94, 94],
  "fsc-mauritius": [607, 385, 132, 124, 94, 112],
  gfsc: [96, 54, 19, 0, 53, 29],
  "guernsey-registry": [248, 100, 0, 0, 145, 72],
  hkma: [660, 94, 0, 0, 94, 94],
  iaasb: [300, 108, 0, 0, 95, 98],
  iais: [250, 53, 0, 0, 56, 53],
  iesba: [300, 111, 0, 0, 95, 103],
  ifrs: [3100, 601, 880, 50, 530, 510],
  "iom-ic": [500, 262, 32, 0, 40, 40],
  iomfsa: [800, 600, 245, 100, 305, 305],
  irs: [300, 105, 0, 0, 114, 105],
  joic: [200, 72, 0, 0, 57, 72],
  mas: [48, 48, 10, 0, 29, 31],
  nist: [295, 39, 0, 0, 142, 39],
  odpa: [200, 50, 0, 0, 47, 47],
  "ombudsman-ky": [476, 116, 0, 0, 116, 116],
  pcaob: [250, 53, 0, 0, 46, 53],
  pci: [192, 58, 0, 0, 87, 58],
  pdpc: [640, 160, 0, 0, 235, 160],
  sfc: [305, 100, 0, 0, 112, 100],
  sra: [300, 38, 0, 0, 40, 38],
  tpr: [300, 125, 0, 0, 125, 125],
  "uk-parliament": [2614, 661, 0, 0, 650, 661],
  "us-doj": [300, 92, 0, 0, 92, 92],
  wolfsberg: [200, 79, 124, 0, 76, 79],
};

/** Clip to the exact symbol rectangle, then contain it in a square without distortion. */
export function artworkCropStyles([imageWidth, imageHeight, x, y, width, height]: ArtworkCrop): {
  frame: CSSProperties;
  image: CSSProperties;
} {
  const edge = Math.max(width, height);
  return {
    frame: { width: `${(width / edge) * 100}%`, height: `${(height / edge) * 100}%` },
    image: {
      position: "absolute",
      maxWidth: "none",
      width: `${(imageWidth / width) * 100}%`,
      height: `${(imageHeight / height) * 100}%`,
      left: `${(-x / width) * 100}%`,
      top: `${(-y / height) * 100}%`,
      objectFit: "fill",
    },
  };
}
